module.exports = __webpack_public_path__ + "img/asus-vivobooka16.72880ffd.png";